<div fxLayout="row" fxLayoutAlign="space-between">
  <div class="dx-field" style="width: 100% !important">
    <div class="dx-field-label" style="width: 100% !important">{{ label }}</div>
    <div class="dx-field-value" style="width: 100% !important">
      <dx-select-box
        id="dropDown"
        [dataSource]="items"
        [dropDownOptions]="{
          minWidth: 250
        }"
        [displayExpr]="displayExpr"
        [(ngModel)]="selectedObject"
        (onSelectionChanged)="selectionChange($event)"
        [valueExpr]="keyExpr"
      >
        <dxo-remote-operations
          *ngIf="remoteOperations"
          [filtering]="true"
          [sorting]="true"
          [paging]="true"
        ></dxo-remote-operations>
        <dx-validator [validationGroup]="validationGroup">
          <dxi-validation-rule
            *ngIf="required"
            type="required"
            [message]="label + ' is required'"
          ></dxi-validation-rule>
        </dx-validator>
      </dx-select-box>
    </div>
  </div>
</div>
